import React, {useState} from "react";
import {Formik} from "formik";
import {EventTriggerForm} from "../../services/HubAndSpokeService";
import {EventTriggersFormFields} from "./EventTriggersFormFields";
import {Spinner} from "../../atoms/spinner";
import {useEventTriggerFormFields} from "./hooks/useEventTriggerFormFields";
import {useEditEventTrigger} from "./hooks/useEditEventTrigger";
import {useDeleteEventTrigger} from "./hooks/useDeleteEventTrigger";
import {HubAndSpokePage} from "./atoms/HubAndSpokePage";
import {ConfirmDeleteModal} from "./atoms/ConfirmDeleteModal";
import {FormCardWrapper} from "./styles";
import {validate} from "./helpers";

export const EventTriggerEdit = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const {mutate: deleteEventTrigger, isLoading: isDeleting} =
    useDeleteEventTrigger();

  const {isLoadingEventTrigger, initialValues, eventTriggerId} =
    useEventTriggerFormFields();

  const {mutate: editEventTrigger, isLoading: isEditing} =
    useEditEventTrigger();

  return (
    <HubAndSpokePage title="Edit Event Trigger">
      {isLoadingEventTrigger ? (
        <Spinner />
      ) : (
        <FormCardWrapper>
          <Formik<EventTriggerForm>
            enableReinitialize
            initialValues={initialValues}
            // https://github.com/jaredpalmer/formik/issues/2675
            onSubmit={() => {
              return;
            }}
            validate={validate}
          >
            <EventTriggersFormFields
              onSubmit={values => editEventTrigger(values)}
              isLoading={isEditing}
              onDelete={() => setIsDeleteModalOpen(true)}
              isDeleting={isDeleting}
            />
          </Formik>
        </FormCardWrapper>
      )}
      <ConfirmDeleteModal
        title="Delete Event Trigger"
        isOpen={isDeleteModalOpen}
        isDeleting={isDeleting}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={() => deleteEventTrigger(eventTriggerId)}
      >
        Are you sure you want to delete this event trigger?
      </ConfirmDeleteModal>
    </HubAndSpokePage>
  );
};
